/**
 * PGLP | Normalização de endereço
 * Mantém a informação original e oferece uma versão normalizada para busca.
 */

const TIPOS = {
  R: 'RUA',
  'R.': 'RUA',
  RUA: 'RUA',
  AV: 'AVENIDA',
  'AV.': 'AVENIDA',
  AVENIDA: 'AVENIDA',
  TRAV: 'TRAVESSA',
  'TRAV.': 'TRAVESSA',
  TRAVESSA: 'TRAVESSA',
  AL: 'ALAMEDA',
  'AL.': 'ALAMEDA',
  ALAMEDA: 'ALAMEDA',
  PC: 'PRAÇA',
  'PC.': 'PRAÇA',
  PRAÇA: 'PRAÇA',
  PRACA: 'PRAÇA',
  ROD: 'RODOVIA',
  'ROD.': 'RODOVIA',
  RODOVIA: 'RODOVIA',
  ESTR: 'ESTRADA',
  'ESTR.': 'ESTRADA',
  ESTRADA: 'ESTRADA'
};

export function normalizarLogradouro(entrada) {
  if (!entrada) return '';

  const texto = String(entrada)
    .replace(/\s+/g, ' ')
    .trim();

  if (!texto) return '';

  const partes = texto.split(' ');
  const primeira = partes[0].toUpperCase();
  const tipo = TIPOS[primeira];

  if (!tipo) {
    return texto;
  }

  const restante = partes.slice(1).join(' ').trim();
  return restante ? `${tipo} ${restante}` : tipo;
}

export function normalizarEndereco(dados = {}) {
  return {
    ...dados,
    logradouro: normalizarLogradouro(dados.logradouro || ''),
    bairro: String(dados.bairro || '').replace(/\s+/g, ' ').trim(),
    cidade: String(dados.cidade || '').replace(/\s+/g, ' ').trim(),
    uf: String(dados.uf || '').trim().toUpperCase(),
    cep: String(dados.cep || '').replace(/\D/g, '').slice(0, 8)
  };
}
